<template>
    <div>
        <textElement
            v-if="message.type === TIM.TYPES.MSG_TEXT"
            :payload="message.payload"
            :message="message"></textElement>
        <customElement
            v-else-if="message.type === TIM.TYPES.MSG_CUSTOM"
            :payload="message.payload"
            :message="message"></customElement>
        <imageElement
            v-else-if="message.type === TIM.TYPES.MSG_IMAGE"
            :payload="message.payload"
            :message="message"></imageElement>
        <fileElement
            v-else-if="message.type === TIM.TYPES.MSG_FILE"
            :payload="message.payload"
            :message="message"></fileElement>
           
    </div>
</template>

<script>
import textElement from './messageElement/textElement';
import customElement from './messageElement/customElement';
import imageElement from './messageElement/imageElement';
import fileElement from './messageElement/fileElement';
export default {
    name: "messageItem",
    components: {
        textElement,
	    customElement,
	    imageElement,
	    fileElement
    },
    props: {
        message: {
            type: Object,
            required: true
        }
    },
    data() {
        return {}
    },
    computed: {
    },
    watch: {},
    mounted() {
    },
    methods: {}
}
</script>

<style scoped lang="less">

</style>
